import { utcMoment, dateTimeFormatted } from '../utilities/dateUtils';
import { PRODUCT_FAMILY_SA } from './productFamily';

// Copy for the final result message; the fallback covers a failure with no backend message.
export const FORCE_ERROR_FALLBACK = 'Failed to create guarantee. Please try again or contact support.';
export const FORCE_SUCCESS_MESSAGE = 'Guarantee created successfully.';

// Fallbacks used only when the backend sends no message of its own.
export const PRODUCTS_ERROR_FALLBACK = 'Error loading products. Please refresh the page and try again.';
export const TRANSACTIONS_ERROR_FALLBACK = 'Error looking up transactions. Please try again.';
export const EVALUATION_ERROR_FALLBACK = 'Error running eligibility checks. Please try again.';
// No blanket "try again": the request may have reached APMS before it failed.
export const FORCE_REQUEST_ERROR_FALLBACK = 'Error creating guarantee. Verify the order before forcing it again '
  + '— the guarantee may already exist.';

// Loader copy for the two long-running steps of the flow.
export const SEARCHING_TRANSACTIONS_MESSAGE = 'Searching transactions...';
export const RUNNING_ELIGIBILITY_MESSAGE = 'Running eligibility checks...';

// Onboarding copy shown until the first search is performed.
export const INSTRUCTIONS_HEADER = 'Force Guarantee';
export const INSTRUCTIONS_STEPS = [
  'Select a product to define which eligibility rules apply. Look up the vehicle by VIN to load its transactions.',
  'Select a transaction from the list.',
  'Run the eligibility check and review the full results log, including the rules that failed.',
  'Confirm with a justification to force-create the guarantee even when eligibility rules fail.',
];

// Backend timestamps are UTC ISO strings; render them like the other transaction tables.
const formatTimestamp = value => (value ? dateTimeFormatted(utcMoment(value)) : '—');

// Columns of the transaction list; `key` is a `guaranteeForceOrdersQuery` field.
export const TRANSACTION_COLUMNS = [
  { key: 'orderId', label: 'Order ID' },
  { key: 'vin', label: 'VIN' },
  { key: 'sellerAccountNumber', label: 'Seller (5M)' },
  { key: 'productOrderState', label: 'Order State' },
  { key: 'ineligibilityType', label: 'Ineligibility Type' },
  { key: 'createdAt', label: 'Created At', format: formatTimestamp },
  { key: 'updatedAt', label: 'Updated At', format: formatTimestamp },
];

// Row action on the Ineligible Purchases tab; the value matches the container's action handler.
export const ROW_ACTION_FORCE_GUARANTEE = 'forceGuarantee';
export const FORCE_GUARANTEE_ACTION_LABEL = 'Force Guarantee / Check All Rules';

// Disabled entry descriptions: DealShield cannot be forced yet, an unknown product can once filtered.
export const FORCE_GUARANTEE_UNSUPPORTED_PRODUCT = 'Not supported yet for DealShield products.';
export const FORCE_GUARANTEE_UNKNOWN_PRODUCT = "This row's product is undetermined. "
  + 'Filter the tab by Seller Guarantee to force it.';

// Shown when the row's order could not be determined in the transaction list.
export const TRANSACTION_NOT_MATCHED_MESSAGE = 'The originating transaction could not be determined for this VIN. '
  + 'Select a transaction to run the eligibility check.';

// Derived from the family constant: family and product code coincide only on the seller side.
export const SELLER_GUARANTEE_PRODUCT_CODE = PRODUCT_FAMILY_SA;
export const FORCEABLE_PRODUCT_CODES = [SELLER_GUARANTEE_PRODUCT_CODE];
